<app-mu-modal-dialog-layout
  *ngIf="formData"
  id="mu-schedule-modal-success"
  [formGroup]="formData"
  [buttonCancel]="true"
  [flagList]="flagList"
  [showFlag]="showFlag"
  [actionFlag]="actionFlag"
  buttonMainActionLabel="form.button.program"
  [loaderFlag]="loaderFlag"
  (eventCancelAction)="canceled()"
  (eventMainAction)="setted()"
>
  <div modalDialogContent class="p-col-12 mu-modal-text mu-without-padding" translate>
    <app-mu-form-fieldset [customGridCol]="12" [customGridColLg]="4">
      <p-calendar
        id="startDateTime"
        name="startDateTime"
        [(ngModel)]="startDateTime"
        [ngModelOptions]="{ standalone: true }"
        [minDate]="baseMinDate"
        [inline]="true"
        [attr.translate]="'no'"
        class="mu-schedule"
        (ngModelChange)="onSelectDateTime()"
        (onClose)="onChangeTime()"
      ></p-calendar>
    </app-mu-form-fieldset>
    <div class="p-col-12 mu-schedule-select">
      <label>{{ 'context.modal.schedule.placeholder' | translate }}</label>
      &nbsp;<i
        class="fa fa-info-circle"
        aria-hidden="true"
        pTooltip="{{ 'context.modal.schedule.tooltip' | translate }}"
        tooltipPosition="top"
      ></i>
    </div>
    <app-mu-form-fieldset [customGridCol]="12" [customGridColLg]="4">
      <p-dropdown
        *ngIf="arrayMinute"
        id="scheduleTime"
        name="scheduleTime"
        (onChange)="onSelectDate($event)"
        [options]="arrayMinute"
        placeholder="{{ 'context.modal.schedule.placeholder' | translate }}"
        (onShow)="validatorService?.scrollToSelected(changeDetectorRef, formData, 'scheduleTime', arrayMinute)"
      >
      </p-dropdown>
    </app-mu-form-fieldset>
  </div>
</app-mu-modal-dialog-layout>
